import { render, staticRenderFns } from "./ProfileInfoCard.vue?vue&type=template&id=3caa3a0b&"
import script from "./ProfileInfoCard.vue?vue&type=script&lang=js&"
export * from "./ProfileInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInfoCard.vue?vue&type=style&index=0&id=3caa3a0b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports